import { BrowserRouter } from "react-router-dom";

import Footer from './layout/Footer'
import Main from './layout/Main'
import Youtube from './layout/Youtube'
import SwiperSection from './layout/Swiper'
import Artist from './layout/Artist'
import Map from './layout/Map'
import './App.scss'

function App() {  
  return (
    <BrowserRouter>
      {/* <Header /> */}
      {/* <Routes>
          <Route path="/" element={<Main />} />
      </Routes> */}
      <div className="container">
        <Main />
        <Youtube />
        <Artist />
        <SwiperSection />
        <Map />
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;